import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { EMRService } from '../EMR.service';

@Component({
  selector: 'app-emr_delete_confirmation_box',
  templateUrl: './emr_delete_confirmation_box.component.html',
  styleUrls: ['./emr_delete_confirmation_box.component.scss']
})
export class Emr_delete_confirmation_boxComponent implements OnInit {

  constructor(public dialog: MatDialog,
    public emrservice: EMRService,
    public dialogRef: MatDialogRef<Emr_delete_confirmation_boxComponent>) { 
      dialogRef.disableClose = true;
    }

  ngOnInit() {
  }

  set_parameter(){
   
    this.dialogRef.close();
  }

  close(){
    this.emrservice.delete_flag = null;
   this.dialogRef.close();
    
  }
}
